<template>

    <modal-container>

        <!-- Top navbar -->
        <modal-header
            :title="'Home Credit product loan'"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <template>

            <!-- Loading animation -->
            <lottie class="loading-animation" :options="{animationData: $root.loadAnimation}" v-if="initLoad"/>

            <!-- Prompt content -->
            <prompt-div v-if="!initLoad">

                <!-- Layout body -->
                <template v-slot:body>

                    <div class="d-flex justify-content-center" style="height: 15rem;">
                        <img src="/images/illustration-happy-shopper.svg" alt="" />
                    </div>

                    <div>
                        <h3 class="font-lg font-weight-bolder">Sorry, we don't have a loan offer for you at this moment</h3>
                        <h4 class="font-md mx-n4 my-4">Your eligibility may change in the future. In the meantime you can let us know if you'd like to have an option to shop with cash here (without loan).</h4>

                        <div v-if="submitted === 'loading'" />
                        <p class="font-md text-gray-disabled" v-else-if="submitted">
                            We have saved your preference.<br />Thank you for your feedback!
                        </p>
                        <div class="mx-n4" v-else>
                            <button class="btn btn-block btn-primary" role="button" @click="submitPreference('cash')">I would like to shop with cash, too</button>
                            <button class="btn btn-block btn-primary mt-4" role="button" @click="submitPreference('installment')">I'm only interested in installments</button>
                        </div>
                    </div>

                </template>

            </prompt-div>

        </template>

    </modal-container>

</template>

<script>
    export default {
        props: {
            params: {
                default: null,
            }
        },

        data: function() {
            return {
                initLoad: false,
                submitted: 'loading',
            }
        },

        created: function() {
            axios
                .get("questionnaire/shopping-preference")
                .then(response => {
                    this.submitted = response.data
                })
        },

        methods: {
            submitPreference(preference) {
                this.initLoad = true
                axios
                    .post("questionnaire/shopping-preference", {
                        'preference': preference,
                    })
                    .then(response => {
                        this.initLoad = false
                        this.submitted = true
                    })
            }
        }
    }
</script>
